var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComunicacoes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_707_2027)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_707_2027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 40.6665V45.9998C38.6667 47.4143 38.1048 48.7709 37.1046 49.7711C36.1045 50.7713 34.7479 51.3332 33.3334 51.3332H12.0001C10.5856 51.3332 9.22904 50.7713 8.22884 49.7711C7.22865 48.7709 6.66675 47.4143 6.66675 45.9998V24.6665C6.66675 23.252 7.22865 21.8955 8.22884 20.8953C9.22904 19.8951 10.5856 19.3332 12.0001 19.3332H17.3334V13.9998C17.3334 12.5853 17.8953 11.2288 18.8955 10.2286C19.8957 9.22841 21.2523 8.6665 22.6667 8.6665H44.0001C45.4146 8.6665 46.7711 9.22841 47.7713 10.2286C48.7715 11.2288 49.3334 12.5853 49.3334 13.9998V35.3332C49.3334 36.7477 48.7715 38.1042 47.7713 39.1044C46.7711 40.1046 45.4146 40.6665 44.0001 40.6665H38.6667Z",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 19.3335H17.3333V24.6668",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 35.3335V40.6668H22.6666",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 19.3335H38.6666V24.6668",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6666 35.3335V40.6668H33.3333",
    stroke: "#FABA36",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_707_2027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(56 56) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_707_2027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(-4 -2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicacoes);
export default __webpack_public_path__ + "static/media/comunicacoes.05b6377b7593e3e682e1fa50b2b0a688.svg";
export { ForwardRef as ReactComponent };